/*
Government Purpose Rights (“GPR”)
Contract No.  W911NF-14-D-0005
Contractor Name:   University of Southern California
Contractor Address:  3720 S. Flower Street, 3rd Floor, Los Angeles, CA 90089-0001
Expiration Date:  Restrictions do not expire, GPR is perpetual
Restrictions Notice/Marking: The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(2) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract.  No restrictions apply after the expiration date shown above. Any reproduction of the software or portions thereof marked with this legend must also reproduce the markings. (see: DFARS 252.227-7014(f)(2)) 
No Commercial Use: This software shall be used for government purposes only and shall not, without the express written permission of the party whose name appears in the restrictive legend, be used, modified, reproduced, released, performed, or displayed for any commercial purpose or disclosed to a person other than subcontractors, suppliers, or prospective subcontractors or suppliers, who require the software to submit offers for, or perform, government contracts.  Prior to disclosing the software, the Contractor shall require the persons to whom disclosure will be made to complete and sign the non-disclosure agreement at 227.7103-7.  (see DFARS 252.227-7025(b)(2))
*/

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import storage from "redux-persist/lib/storage";

import data from "./slices/data";
import userData from "./slices/userData";
import dialogue from "./slices/dialogue";
import drawer from "./slices/drawer";
import settings from "./slices/settings";
import lesson from "./slices/lesson";
import firstTimeData from "./slices/firstTimeData";

const ENABLE_REDUX_DEV_TOOLS = true;
const encryptor = encryptTransform({
  secretKey: process.env.ADMIN_SECRET || "admin-secret",
  onError: function (error: Error) {
    console.error(error);
    throw new Error(error.message);
  },
});

const dataConfig = {
  key: "data",
  storage: storage,
  blacklist: [],
};
const userDataConfig = {
  key: "userData",
  storage: storage,
  blacklist: [
    "recordSaveState",
    "planSaveState",
    "userTestSaveState",
    "recordsProcessed",
  ],
  transforms: [encryptor],
};
const firstTimeDataConfig = {
  key: "firstTimeData",
  storage: storage,
};
const settingsConfig = {
  key: "settings",
  storage: storage,
};

export const store = configureStore({
  reducer: combineReducers({
    // cache the following:
    data: persistReducer(dataConfig, data),
    userData: persistReducer(userDataConfig, userData),
    settings: persistReducer(settingsConfig, settings),
    firstTimeData: persistReducer(firstTimeDataConfig, firstTimeData),

    // do *not* cache this:
    dialogue: dialogue,
    drawer: drawer,
    lesson: lesson,
  }),
  devTools: ENABLE_REDUX_DEV_TOOLS,
});
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
